import { render } from "./RenameFileModal.vue?vue&type=template&id=456e4f33&scoped=true"
import script from "./RenameFileModal.vue?vue&type=script&lang=js"
export * from "./RenameFileModal.vue?vue&type=script&lang=js"

import "./RenameFileModal.vue?vue&type=style&index=0&id=456e4f33&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456e4f33"]])

export default __exports__